<div class="dashboard-container">
  <!-- Header -->
  <app-staff-header
    [currentUser]="currentUser"
    (logout)="onLogout()">
  </app-staff-header>

  <!-- Main Content -->
  <div class="dashboard-content">
    <!-- Navigation -->
    <app-staff-nav
      [isMobileMenuOpen]="isMobileMenuOpen"
      (navigate)="onNavigate($event)"
      (mobileMenuClose)="closeMobileMenu()"
      (desktopSidebarToggle)="onDesktopSidebarToggle($event)">
    </app-staff-nav>

    <!-- Content Area -->
    <div class="dashboard-main" [class.sidebar-collapsed]="isDesktopSidebarCollapsed">
      <div class="main-content">
        <!-- Page Header -->
        <div class="content-header">
          <h1 class="page-title">ข้อมูลอ้างอิงผู้ใช้งาน</h1>
          <p class="page-subtitle">ระบบจัดการข้อมูลอ้างอิงสมาชิก VAT (Reference User Data)</p>
        </div>

        <!-- Error Alert -->
        <ngb-alert
          *ngIf="error"
          type="danger"
          [dismissible]="true"
          (closed)="error = null"
          class="mb-3">
          {{ error }}
        </ngb-alert>

        <!-- Summary Cards (สถานะการสมัคร) -->
        <div class="summary-cards summary-cards-3">
          <button
            type="button"
            class="summary-card"
            [class.active]="filters.registration === 'all'"
            (click)="setRegistrationFilter('all')">
            <div class="summary-info">
              <span class="summary-label">ทั้งหมด</span>
              <span class="summary-value">{{ stats.total }}</span>
            </div>
            <span class="summary-badge bg-secondary">
              <i class="bi bi-people-fill"></i>
            </span>
          </button>

          <button
            type="button"
            class="summary-card"
            [class.active]="filters.registration === 'registered'"
            (click)="setRegistrationFilter('registered')">
            <div class="summary-info">
              <span class="summary-label">สมัครเข้าระบบแล้ว</span>
              <span class="summary-value">{{ stats.registered }}</span>
            </div>
            <span class="summary-badge bg-success">
              <i class="bi bi-person-check-fill"></i>
            </span>
          </button>

          <button
            type="button"
            class="summary-card"
            [class.active]="filters.registration === 'not-registered'"
            (click)="setRegistrationFilter('not-registered')">
            <div class="summary-info">
              <span class="summary-label">ยังไม่สมัคร</span>
              <span class="summary-value">{{ stats.notRegistered }}</span>
            </div>
            <span class="summary-badge bg-warning">
              <i class="bi bi-person-dash-fill"></i>
            </span>
          </button>
        </div>

        <!-- Filters Section -->
        <div class="filters-section">
          <div class="filters-header">
            <h3>ตัวกรอง</h3>
            <button
              type="button"
              class="clear-filters-btn"
              (click)="clearFilters()">
              ล้างตัวกรอง
            </button>
          </div>

          <div class="filters-grid">
            <!-- Search Term -->
            <div class="filter-group">
              <label class="form-label">ค้นหาทั่วไป</label>
              <input
                type="text"
                class="form-control"
                [(ngModel)]="filters.searchTerm"
                (ngModelChange)="applyFilters()"
                placeholder="ชื่อ, นามสกุล, เลขบัตร หรือ รหัสสมาชิก">
            </div>

            <!-- ID Card Search -->
            <div class="filter-group">
              <label class="form-label">เลขบัตรประชาชน</label>
              <input
                type="text"
                class="form-control"
                [(ngModel)]="filters.idCardSearch"
                (ngModelChange)="applyFilters()"
                placeholder="เลขบัตรประชาชน">
            </div>

            <!-- Member ID Search -->
            <div class="filter-group">
              <label class="form-label">รหัสสมาชิก</label>
              <input
                type="text"
                class="form-control"
                [(ngModel)]="filters.memberIdSearch"
                (ngModelChange)="applyFilters()"
                placeholder="เช่น ส.41-1083">
            </div>

            <!-- Registration Filter -->
            <div class="filter-group">
              <label class="form-label">สถานะการสมัคร</label>
              <select
                class="form-select"
                [(ngModel)]="filters.registration"
                (ngModelChange)="applyFilters()">
                <option value="all">ทั้งหมด</option>
                <option value="registered">สมัครแล้ว</option>
                <option value="not-registered">ยังไม่สมัคร</option>
              </select>
            </div>

            <!-- Expiration Filter -->
            <div class="filter-group">
              <label class="form-label">สถานะวันหมดอายุ</label>
              <select
                class="form-select"
                [(ngModel)]="filters.expiration"
                (ngModelChange)="applyFilters()">
                <option value="all">ทั้งหมด</option>
                <option value="lifetime">ตลอดชีพ</option>
                <option value="dated">มีวันหมดอายุ</option>
                <option value="none">ไม่ระบุวันหมดอายุ</option>
              </select>
            </div>
          </div>

          <!-- Action Buttons -->
          <div class="d-flex gap-2 mt-3">
            <button
              type="button"
              class="btn btn-success"
              (click)="openCreateModal()">
              <i class="bi bi-plus-lg me-2"></i>เพิ่มข้อมูล
            </button>
            <button
              type="button"
              class="btn btn-outline-success"
              (click)="exportToCSV()"
              [disabled]="filteredData.length === 0">
              <i class="bi bi-file-earmark-excel me-2"></i>Export CSV
            </button>
            <button
              type="button"
              class="btn btn-primary"
              (click)="refreshData()">
              <i class="bi bi-arrow-clockwise me-2"></i>รีเฟรชข้อมูล
            </button>
          </div>
        </div>

        <!-- Loading Spinner -->
        <div *ngIf="isLoading" class="reference-data-container">
          <div class="loading-state">
            <div class="loading-spinner"></div>
            <p>กำลังโหลดข้อมูลอ้างอิงผู้ใช้งาน...</p>
          </div>
        </div>

        <!-- Data Table -->
        <div class="card" *ngIf="!isLoading">
          <div class="card-header d-flex justify-content-between align-items-center">
            <h5 class="card-title mb-0">รายการข้อมูลอ้างอิง</h5>
            <div class="d-flex align-items-center gap-2">
              <span class="text-muted">แสดงผล:</span>
              <select class="form-select form-select-sm w-auto" [(ngModel)]="pageSize"
                  (ngModelChange)="changePageSize(pageSize)" aria-label="จำนวนรายการต่อหน้า">
                  <option *ngFor="let size of pageSizeOptions" [ngValue]="size">{{ size }} รายการ</option>
                </select>
            </div>
          </div>

          <div class="card-body p-0">
            <!-- Table -->
            <div class="table-responsive">
              <table class="table table-striped table-hover mb-0">
                <thead class="table-light">
                  <tr>
                    <th scope="col" class="text-center">#</th>
                    <th scope="col" class="sortable" (click)="sortBy('name')">
                      ชื่อ-สกุล {{ getSortIcon('name') }}
                    </th>
                    <th scope="col" class="sortable" (click)="sortBy('idCardNumber')">
                      เลขบัตรประชาชน {{ getSortIcon('idCardNumber') }}
                    </th>
                    <th scope="col" class="sortable" (click)="sortBy('idMember')">
                      รหัสสมาชิก {{ getSortIcon('idMember') }}
                    </th>
                    <th scope="col" class="sortable text-center" (click)="sortBy('expirationDate')">
                      วันหมดอายุ {{ getSortIcon('expirationDate') }}
                    </th>
                    <th scope="col" class="text-center">สถานะการสมัคร</th>
                    <th scope="col" class="text-center">จัดการ</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- No Data Row -->
                  <tr *ngIf="getCurrentPageData().length === 0">
                    <td colspan="7" class="text-center py-4">
                      <div class="text-muted">
                        <i class="bi bi-inbox"></i>
                        <p class="mb-0">ไม่พบข้อมูลอ้างอิงผู้ใช้งาน</p>
                        <small *ngIf="allData.length === 0">ไม่มีข้อมูลในระบบ</small>
                        <small *ngIf="allData.length > 0 && filteredData.length === 0">ไม่พบข้อมูลที่ตรงกับเงื่อนไขการกรอง</small>
                      </div>
                    </td>
                  </tr>

                  <!-- Data Rows -->
                  <tr *ngFor="let record of getCurrentPageData(); let i = index; trackBy: trackByRecordId"
                      class="clickable-row"
                      (click)="openEditModal(record)"
                      title="คลิกเพื่อแก้ไขข้อมูล">
                    <td class="text-center text-muted">
                      {{ (page - 1) * pageSize + i + 1 }}
                    </td>
                    <td>
                      <h6 class="mb-0">{{ getFullName(record) || '-' }}</h6>
                    </td>
                    <td>
                      <span class="font-monospace">{{ record.idCardNumber || '-' }}</span>
                    </td>
                    <td>
                      <span class="badge bg-light text-dark border">{{ record.idMember || '-' }}</span>
                    </td>
                    <td class="text-center">
                      <span class="badge" [ngClass]="getExpirationBadgeClass(record)">
                        {{ record.expirationDate || 'ไม่ระบุ' }}
                      </span>
                    </td>
                    <td class="text-center">
                      <span
                        *ngIf="record.hasRegistered"
                        class="badge bg-success registration-badge">
                        <i class="bi bi-check-circle-fill me-1"></i>สมัครแล้ว
                      </span>
                      <span
                        *ngIf="!record.hasRegistered"
                        class="badge bg-secondary registration-badge">
                        <i class="bi bi-dash-circle me-1"></i>ยังไม่สมัคร
                      </span>
                    </td>
                    <td class="text-center">
                      <button
                        type="button"
                        class="btn btn-sm"
                        [class.btn-outline-secondary]="record.hasRegistered"
                        [class.btn-outline-primary]="!record.hasRegistered"
                        (click)="openEditModal(record, $event)"
                        [ngbTooltip]="record.hasRegistered ? 'ดูข้อมูล (สมัครแล้ว)' : 'แก้ไขข้อมูล'"
                        placement="left">
                        <i [ngClass]="record.hasRegistered ? 'bi bi-eye' : 'bi bi-pencil-square'"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- Pagination -->
          <div class="card-footer">
            <div class="d-flex justify-content-between align-items-center">
              <div class="text-muted">
                แสดงผล {{ collectionSize === 0 ? 0 : ((page - 1) * pageSize) + 1 }} - {{ min(page * pageSize, collectionSize) }}
                จาก {{ collectionSize }} รายการ
              </div>
              <ngb-pagination
                [(page)]="page"
                [pageSize]="pageSize"
                [collectionSize]="collectionSize"
                [maxSize]="5"
                [rotate]="true"
                [boundaryLinks]="true"
                [size]="'sm'">
              </ngb-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
